import React from 'react';
export function TestimonialsSection() {
  const testimonials = [{
    name: 'Martín S.',
    city: 'Buenos Aires',
    text: 'Doy clases hace 5 años y siempre perdía horas armando ejercicios. Este kit me salvó. Los alumnos notan la diferencia.',
    role: 'Profesor particular'
  }, {
    name: 'Laura G.',
    city: 'Córdoba',
    text: 'El tomo de creatividad es increíble. Mis alumnos ahora improvisan y se divierten mucho más.',
    role: 'Docente en academia'
  }, {
    name: 'Diego F.',
    city: 'Rosario',
    text: 'Los juegos musicales me ayudaron a retener alumnos que estaban por dejar. Todo estructurado, mucha paz mental.',
    role: 'Profesor de piano'
  }, {
    name: 'Carolina M.',
    city: 'Mendoza',
    text: 'La planificación anual es oro puro. Entro a clase sabiendo exactamente qué toca hoy y la semana que viene.',
    role: 'Docente independiente'
  }, {
    name: 'Javier P.',
    city: 'La Plata',
    text: 'El repertorio está muy bien elegido. Antes perdía tiempo buscando partituras, ahora tengo todo clasificado.',
    role: 'Profesor de teclado'
  }];
  return <section className="bg-[#0a1128] py-4 md:py-6 px-3 border-y border-[#1e293b]" data-id="element-163">
      <div className="max-w-4xl mx-auto" data-id="element-164">
        <h2 className="text-2xl md:text-3xl font-black text-white text-center mb-4" data-id="element-165">
          Lo que dicen otros docentes
        </h2>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-2" data-id="element-166">
          {testimonials.map((t, i) => <div key={i} className="bg-[#050a1a] border border-[#1e293b] p-3 rounded-xl flex flex-col" data-id="element-167">
              <div className="text-[#eab308] text-xs mb-1.5" data-id="element-168">★★★★★</div>
              <p className="text-gray-300 italic text-xs mb-2 flex-grow" data-id="element-169">
                "{t.text}"
              </p>
              <div className="border-t border-[#1e293b] pt-2" data-id="element-170">
                <p className="font-bold text-white text-sm" data-id="element-171">{t.name}</p>
                <p className="text-[10px] text-gray-500" data-id="element-172">
                  {t.role} • {t.city}
                </p>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}